import { Box, CircularProgress } from '@mui/material';
import GatewayLogo from '../Assets/images/logo-web-gateway.png';

const SplashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000,
    }}
  >
    <Box
      component="img"
      src={GatewayLogo}
      alt="Gateway"
      sx={{ width: 200, height: 'auto' }}
    />
    <CircularProgress
size={28}
thickness={3}
sx={{ color: '#3A6983' }}
    />
  </Box>
);

export default SplashScreen;
